import React, { useState, useContext } from "react";
import {
  Avatar,
  Box,
  Paper,
  Container,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import { AuthContext } from "Firebase/AuthProvider";
import { BuildingContext } from "Context/BuildingProvider";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import TableLoading from "components/Misc/TableLoading";
import ErrorMessage from "components/Misc/ErrorMessage";
import Page from "components/Page";
import { EditOutlined } from "@material-ui/icons";
import { GET_PATROLS } from "lib/roles";
import { GetPatrolsQueryResult, Task } from "generated/graphql";

export default function PatrolsData() {
  const history = useHistory();
  const { currentBuilding, updateBuilding } = useContext(BuildingContext);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  const { loading, error, data }: GetPatrolsQueryResult = useQuery(
    GET_PATROLS,
    {
      variables: {
        limit,
        offset: limit * page,
        buildingId: currentBuilding?.Id,
      },
    }
  );

  const handleEditClick = (id: string) => {};

  const handleLimitChange = (event: any) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event: any, newPage: any) => {
    setPage(newPage);
  };
  if (loading) {
    return <TableLoading />;
  } else if (error) {
    return <ErrorMessage message={error.message}></ErrorMessage>;
  } else if (!!data?.RoleInstance) {
    return (
      <React.Fragment>
        <Paper className="container">
          <PerfectScrollbar>
            <Box>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Guard</TableCell>
                    <TableCell>Patrol Name</TableCell>
                    <TableCell>Start Time</TableCell>
                    <TableCell>End Time</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.RoleInstance.slice(0, limit).map((patrol) => (
                    <TableRow hover key={patrol.Id}>
                      <TableCell component="th" scope="row">
                        {patrol?.Shift_Gaurd?.Gaurd?.GaurdFirstName}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {patrol.Role?.Title}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {patrol.timeStart}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {patrol.DateTimeEnd}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          <TablePagination
            component="div"
            count={
              data.RoleInstance_aggregate.aggregate?.count
                ? data.RoleInstance_aggregate.aggregate?.count
                : 0
            }
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Paper>
      </React.Fragment>
    );
  } else {
    return <div>No Patrols</div>;
  }
}
